module.exports = __webpack_public_path__ + "static/scale-model-of-steel-lake-park-in-kent-washington-3c2ff3ba69273a7c267633f1bd071ca4.png";